module.exports = __webpack_public_path__ + "static/media/11.3f67f299.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/11.jpg
// module id = 470
// module chunks = 0